var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoF = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 20,
    viewBox: "0 0 105 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.207,
    y1: 0.207,
    x2: 0.844,
    y2: 0.844,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0596ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0692f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#0f6bb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#154f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#193d6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a3761"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69144",
    "data-name": "Group 69144",
    transform: "translate(15789 1122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148977",
    "data-name": "Rectangle 148977",
    width: 105,
    height: 30,
    transform: "translate(-15789 -1122)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-15788 -1119.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M112.47,0h12.219V2.737h-9.175V7.7h8.175v2.717h-8.175v6.591H112.47Zm14.788,17.017H130.3V0h-3.044Zm22.45-12.941a8.5,8.5,0,0,1,1.157,4.422,8.5,8.5,0,0,1-1.157,4.422,7.915,7.915,0,0,1-3.252,3.012,10.342,10.342,0,0,1-4.751,1.064h-7.227V0h7.227a10.349,10.349,0,0,1,4.751,1.064,7.917,7.917,0,0,1,3.252,3.012Zm-2.653,1.413a5.218,5.218,0,0,0-2.172-2.019,7.22,7.22,0,0,0-3.319-.737h-4.043V14.273h4.043a7.22,7.22,0,0,0,3.319-.737,5.235,5.235,0,0,0,2.172-2.019,5.864,5.864,0,0,0,.766-3.022,5.861,5.861,0,0,0-.766-3.012Zm9.7,4.24h8.168v-2.7h-8.168V2.737h9.178V0H153.716V17.012h12.543V14.27h-9.5ZM187.358,0h-2.471l-6.5,11.111L171.788,0h-2.471V17.012h2.948V6.137l5.336,8.9h1.474l5.333-8.962.022,10.941h2.948Z",
    transform: "translate(-84.841 0.006)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Believe_you_can-2",
    "data-name": "Believe you can-2",
    transform: "translate(27.98 18.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69143",
    "data-name": "Group 69143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M118.226,80.926a1.349,1.349,0,0,1,.268.857,1.228,1.228,0,0,1-.523,1.069,2.6,2.6,0,0,1-1.523.373H113.9V77.885h2.4a2.344,2.344,0,0,1,1.415.366,1.184,1.184,0,0,1,.491,1.015A1.317,1.317,0,0,1,118,80a1.26,1.26,0,0,1-.521.467A1.373,1.373,0,0,1,118.226,80.926ZM114.662,78.5v1.72h1.565a1.587,1.587,0,0,0,.9-.216.8.8,0,0,0,0-1.275,1.585,1.585,0,0,0-.9-.219Zm2.732,3.894a.737.737,0,0,0,.329-.673q0-.892-1.3-.892h-1.756v1.779h1.756A1.8,1.8,0,0,0,117.393,82.4Z",
    transform: "translate(-113.9 -77.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M139.463,85.308h-3.279a1.263,1.263,0,0,0,.469.86,1.528,1.528,0,0,0,.995.324A1.494,1.494,0,0,0,138.815,86l.405.474a1.788,1.788,0,0,1-.683.491,2.582,2.582,0,0,1-2.049-.1,1.879,1.879,0,0,1-.766-.737,2.1,2.1,0,0,1-.273-1.069A2.14,2.14,0,0,1,135.714,84a1.884,1.884,0,0,1,.725-.737A2.071,2.071,0,0,1,137.481,83a2.042,2.042,0,0,1,1.034.263,1.879,1.879,0,0,1,.71.737,2.263,2.263,0,0,1,.246,1.083A.914.914,0,0,1,139.463,85.308ZM136.6,83.943a1.29,1.29,0,0,0-.415.84h2.594a1.307,1.307,0,0,0-.415-.835,1.368,1.368,0,0,0-1.764,0Z",
    transform: "translate(-130.155 -81.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M156,76.59h.737v5.65H156Z",
    transform: "translate(-145.658 -76.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M164.27,76.944a.452.452,0,0,1-.14-.337.469.469,0,0,1,.14-.339.53.53,0,0,1,.71-.007.437.437,0,0,1,.14.332.491.491,0,0,1-.14.349.523.523,0,0,1-.71,0Zm0,.916h.737V81.9h-.737Z",
    transform: "translate(-151.79 -76.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M175.813,85.308h-3.282a1.273,1.273,0,0,0,.469.86,1.533,1.533,0,0,0,.995.324A1.5,1.5,0,0,0,175.165,86l.4.474a1.769,1.769,0,0,1-.683.491,2.582,2.582,0,0,1-2.049-.1,1.909,1.909,0,0,1-.766-.737,2.12,2.12,0,0,1-.27-1.069A2.164,2.164,0,0,1,172.062,84a1.9,1.9,0,0,1,.725-.737A2.076,2.076,0,0,1,173.828,83a2.036,2.036,0,0,1,1.034.263,1.864,1.864,0,0,1,.71.737,2.262,2.262,0,0,1,.246,1.083A2.148,2.148,0,0,1,175.813,85.308Zm-2.867-1.366a1.3,1.3,0,0,0-.415.84h2.594a1.3,1.3,0,0,0-.415-.835,1.368,1.368,0,0,0-1.764,0Z",
    transform: "translate(-157.576 -81.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M193.449,83.18l-1.771,4.043h-.737L189.17,83.18h.764l1.388,3.243,1.42-3.243Z",
    transform: "translate(-170.68 -81.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M211.413,85.308h-3.282a1.273,1.273,0,0,0,.469.86,1.533,1.533,0,0,0,.995.324A1.5,1.5,0,0,0,210.764,86l.4.474a1.769,1.769,0,0,1-.683.491,2.582,2.582,0,0,1-2.049-.1,1.894,1.894,0,0,1-.766-.737,2.1,2.1,0,0,1-.27-1.069A2.137,2.137,0,0,1,207.662,84a1.9,1.9,0,0,1,.725-.737A2.076,2.076,0,0,1,209.428,83a2.036,2.036,0,0,1,1.034.263,1.879,1.879,0,0,1,.71.737,2.262,2.262,0,0,1,.246,1.083A2.148,2.148,0,0,1,211.413,85.308Zm-2.867-1.366a1.29,1.29,0,0,0-.415.84h2.594a1.3,1.3,0,0,0-.415-.835,1.368,1.368,0,0,0-1.764,0Z",
    transform: "translate(-184.43 -81.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M237.214,83.18l-1.965,4.449a1.992,1.992,0,0,1-.607.87,1.386,1.386,0,0,1-.835.246,1.742,1.742,0,0,1-.575-.1,1.162,1.162,0,0,1-.462-.28l.312-.548a1.027,1.027,0,0,0,.725.3.693.693,0,0,0,.447-.142,1.228,1.228,0,0,0,.324-.491l.13-.283-1.783-4.021h.762l1.413,3.235,1.4-3.235Z",
    transform: "translate(-203.569 -81.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M252.684,86.874a1.9,1.9,0,0,1-.752-.737,2.211,2.211,0,0,1,0-2.127,1.9,1.9,0,0,1,.752-.737,2.353,2.353,0,0,1,2.162,0,1.923,1.923,0,0,1,.749.737,2.228,2.228,0,0,1,0,2.127,1.928,1.928,0,0,1-.749.737A2.316,2.316,0,0,1,252.684,86.874Zm1.781-.553a1.273,1.273,0,0,0,.491-.491,1.656,1.656,0,0,0,0-1.489,1.228,1.228,0,0,0-.491-.491,1.474,1.474,0,0,0-1.4,0,1.251,1.251,0,0,0-.491.491,1.634,1.634,0,0,0,0,1.489,1.3,1.3,0,0,0,.491.491,1.452,1.452,0,0,0,1.4,0Z",
    transform: "translate(-217.818 -81.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M276.553,83.18v4.043h-.7v-.609a1.474,1.474,0,0,1-.585.491,1.8,1.8,0,0,1-.789.172,1.764,1.764,0,0,1-1.275-.457,1.744,1.744,0,0,1-.464-1.317V83.18h.737v2.243a1.25,1.25,0,0,0,.283.889,1.049,1.049,0,0,0,.808.3,1.211,1.211,0,0,0,.916-.351,1.378,1.378,0,0,0,.334-.983v-2.1Z",
    transform: "translate(-233.721 -81.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M301.824,86.865a1.965,1.965,0,0,1-.759-.737,2.194,2.194,0,0,1,0-2.127,1.948,1.948,0,0,1,.759-.737,2.287,2.287,0,0,1,1.1-.265,2.118,2.118,0,0,1,.983.221,1.587,1.587,0,0,1,.668.641l-.56.366a1.265,1.265,0,0,0-.469-.437,1.366,1.366,0,0,0-.626-.145,1.432,1.432,0,0,0-.712.177,1.228,1.228,0,0,0-.491.491,1.634,1.634,0,0,0,0,1.489,1.25,1.25,0,0,0,.491.491,1.457,1.457,0,0,0,.712.174,1.366,1.366,0,0,0,.626-.145,1.228,1.228,0,0,0,.472-.435l.558.351a1.592,1.592,0,0,1-.668.644,2.088,2.088,0,0,1-.983.226,2.235,2.235,0,0,1-1.1-.243Z",
    transform: "translate(-254.879 -81.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M321.829,83.4a1.594,1.594,0,0,1,.447,1.228v2.442h-.7v-.533a1.147,1.147,0,0,1-.521.43,1.982,1.982,0,0,1-.806.15,1.685,1.685,0,0,1-1.088-.329,1.051,1.051,0,0,1-.408-.857,1.064,1.064,0,0,1,.388-.857,1.907,1.907,0,0,1,1.228-.324h1.159v-.145a.926.926,0,0,0-.275-.737,1.152,1.152,0,0,0-.808-.246,2.142,2.142,0,0,0-.7.118,1.8,1.8,0,0,0-.58.317l-.3-.548a2.152,2.152,0,0,1,.737-.386,3.145,3.145,0,0,1,.936-.14A1.823,1.823,0,0,1,321.829,83.4Zm-.737,2.965a1.081,1.081,0,0,0,.442-.531v-.565H320.4q-.931,0-.931.626a.57.57,0,0,0,.246.491,1.1,1.1,0,0,0,.658.174,1.361,1.361,0,0,0,.725-.2Z",
    transform: "translate(-268.433 -81.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M341.988,83.447a1.759,1.759,0,0,1,.452,1.309v2.326H341.7V84.839a1.228,1.228,0,0,0-.283-.884,1.056,1.056,0,0,0-.808-.3,1.26,1.26,0,0,0-.931.349,1.356,1.356,0,0,0-.344.983V87.07H338.6V83.039h.7v.609a1.4,1.4,0,0,1,.6-.491,2.071,2.071,0,0,1,.86-.162A1.68,1.68,0,0,1,341.988,83.447Z",
    transform: "translate(-283.401 -81.306)"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    cx: 12.261,
    cy: 12.261,
    r: 12.261,
    transform: "translate(0 0.002)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M30.617,37.265l8.013,8.013a12.194,12.194,0,0,1-3.154.86L28.61,39.26Zm.816-.816,8.3,8.3a12.253,12.253,0,0,0,2.344-1.668l-8.635-8.635ZM39.08,28.8l-2.007,2.014,8.033,8.033a12.2,12.2,0,0,0,.877-3.135Zm-4.827,4.83,8.635,8.635a12.244,12.244,0,0,0,1.68-2.334L36.26,31.623Z",
    transform: "translate(-21.582 -21.724)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M26.87,62.93a1.417,1.417,0,1,0,.414-1A1.42,1.42,0,0,0,26.87,62.93Z",
    transform: "translate(-20.269 -46.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M38.35,51.427a1.417,1.417,0,1,0,.413-1.01A1.42,1.42,0,0,0,38.35,51.427Z",
    transform: "translate(-28.929 -37.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M62.732,27.06a1.42,1.42,0,1,0,1.417,1.42A1.42,1.42,0,0,0,62.732,27.06Z",
    transform: "translate(-46.249 -20.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M49.84,39.967a1.42,1.42,0,1,0,1.417-1.417,1.42,1.42,0,0,0-1.417,1.417Z",
    transform: "translate(-37.597 -29.078)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoF, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logoF.91f4fa57.svg";
export { ForwardRef as ReactComponent };